/**
 * InventoryPage — Tab wrapper con Outlet y PageHeader con ayuda contextual.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  stock:      { title: 'Stock', subtitle: 'Vista consolidada de existencias por bodega y producto.', helpKey: 'inventory.stock' },
  warehouses: { title: 'Bodegas', subtitle: 'Administra las bodegas y almacenes de la empresa.', helpKey: 'inventory.warehouses' },
  movements:  { title: 'Movimientos', subtitle: 'Historial de entradas, salidas y ajustes de stock.', helpKey: 'inventory.movements' },
  counts:     { title: 'Conteos', subtitle: 'Tomas de inventario y ajustes por diferencias.', helpKey: 'inventory.counts' },
  transfers:  { title: 'Transferencias', subtitle: 'Transferencias de mercadería entre bodegas.', helpKey: 'inventory.transfers' },
}

export default function InventoryPage() {
  const { pathname } = useLocation()
  const segment = pathname.split('/').pop() || 'stock'
  const meta = PAGE_META[segment] || PAGE_META.stock

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
